import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Visitor } from '../../models/visitor';
import { VisitorService } from '../../services/visitor.service';
import { map } from 'rxjs/operators';
import { VisitorChild } from '../../models/visitorChild';
import { Visitor1 } from '../../models/visitor1';
import { VisitorChild1 } from '../../models/visitorChild1';
import { Visit } from '../../models/visit.model';
import { VisitService } from '../../services/visit.service';
import { PlayroomService } from '../../services/playroom.service';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { Playroom } from '../../models/playroom.model';
import { CostumArray } from '../../models/customArray';
import { RoomArray } from '../../models/roomArray';
import { ZoneArray } from '../../models/zoneArray';
import { Zone } from '../../models/zone.model';
import { RodjendanskezoneService } from '../../services/rodjendanskezone.service';
import { BirthDay } from '../../models/birthday.model';
import { User } from 'src/app/models/user.model';
import { UserService } from '../../services/user.service';
import { validateBirthDay } from 'src/app/utils/formValidators';
import { CommonMethodesService } from '../../services/common-methodes.service';
import { CalendarWeek } from '../../models/CalendarWeek';
import { TimeSlotConfigurationService } from '../../services/time-slot-configuration.service';
import { CalendarSlotCell } from '../../models/CalendarSlotCell';
import { SlotsbyDate } from '../../models/SlotsbyDate';
import { CallListService } from '../../services/call-list.service';
import { NotifierService } from 'angular-notifier';
import { LanguageService } from 'src/app/services/language.service';
import { BirthdayOutput } from '../kartica-visitora/kartica-visitora.page';
import { BirthdayModelInputDTO } from '../../models/birthdayModelInputDTO';

@Component({
  selector: 'app-visitors-card-from-booking',
  templateUrl: './visitors-card-from-booking.component.html',
  styleUrls: ['./visitors-card-from-booking.component.scss'],
})
export class VisitorsCardFromBookingComponent implements OnInit {
  visitor: Visitor1;
  visits: Visit[]
  visitorCh: VisitorChild1[]

  itemsPerPage: number = 2147483647;
  isAddBirthay: boolean = false

  usernameQuery: string = '';
  fullNameQuery: string = '';

  emailQuery: string = '';
  phoneQuery: string = '';
  visitorStatusQuery: string = '';
  currentPage: number = 1;
  onlyChildren: boolean = false;
  marketingMessageQuery: string = '';

  message: string = ''

  constructor(private route: ActivatedRoute, private visitorService: VisitorService,
    private visitService: VisitService,
    private roomService: PlayroomService,
    private rodjendanskezoneservice: RodjendanskezoneService,
    private userService: UserService,
    private commonMethodsService: CommonMethodesService,
    private navCtrl: NavController,
    private timeSlotService: TimeSlotConfigurationService,
    private callListService: CallListService,
    private notifierService: NotifierService,
    private languageService: LanguageService,
    private router: Router,
    private toastController: ToastController
  ) { }

  async presentToast(message: string, color: 'success' | 'danger' = 'success') {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      color,
      position: 'bottom',
      cssClass: 'custom-toast'
    });

    await toast.present();
  }

  visitors$ = this.visitorService.visitors$;
  visits$ = this.visitService.visit$
  errMsg = '';
  paginationSettings = { totalItems: 0 };
  birthDateQuery: string = '';
  roomQuery: string = '';
  statusQuery: string = '';
  registrationDateFromQuery: string = ""
  registrationDateToQuery: string = ""
  dateQuery: string = '';
  dateQueryEnd: string = '';
  roomName: string = '';
  enterTimeQuery: string = '';
  enterTimeQueryEnd: string = '';
  packageTicketType: string = '';
  dateBirthFromQuery: string = ''
  dateBirthToQuery: string = ''
  visitorBirthMonthFromQuery: string = ""
  visitorBirthMonthToQuery: string = ""
  visitorBirthYearFromQuery: string = ""
  visitorBirthYearToQuery: string = ""
  timeZoneQuery: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  gratis: boolean
  gratisQuery: string = ""
  playroom: Playroom[]
  userList: Array<CostumArray>;
  selectedUser: CostumArray | null = null
  roomList: Array<RoomArray>;
  selectedRoom: RoomArray | null = null
  zoneList: Array<ZoneArray>
  selectedZone: ZoneArray | null = null
  birthdayAdd: BirthdayModelInputDTO
  startTimeBirthdayQuery = ''
  endTimeBirthdayQuery = ''
  zone: Zone[]
  users: User[];
  availibleslots: SlotsbyDate[] = []
  isCreateMode = false;
  createChildren: Array<{ fullName: string; birthDate: string }> = [
    { fullName: '', birthDate: '' },
  ];
  phonePrefixes = [
    { code: '+381', flag: 'rs' }, // Srbija  
    { code: '+387', flag: 'ba' }, // Bosna i Hercegovina
    { code: '+389', flag: 'mk' }, // Severna Makedonija  
    { code: '+385', flag: 'hr' }, // Hrvatska  
    { code: '+382', flag: 'me' }, // Crna Gora
    { code: '+7', flag: 'ru' }, // Rusija  
    { code: '+380', flag: 'ua' }, // Ukrajina  
    { code: '+49', flag: 'de' }, // Nemačka 
    { code: '+355', flag: 'al' }, // Albanija  
    { code: '+376', flag: 'ad' }, // Andora  
    { code: '+43', flag: 'at' }, // Austrija  
    { code: '+374', flag: 'am' }, // Jermenija  
    { code: '+32', flag: 'be' }, // Belgija   
    { code: '+359', flag: 'bg' }, // Bugarska  
    { code: '+357', flag: 'cy' }, // Kipar  
    { code: '+420', flag: 'cz' }, // Češka  
    { code: '+45', flag: 'dk' }, // Danska  
    { code: '+372', flag: 'ee' }, // Estonija  
    { code: '+358', flag: 'fi' }, // Finska  
    { code: '+33', flag: 'fr' }, // Francuska  
    { code: '+995', flag: 'ge' }, // Gruzija  
    { code: '+30', flag: 'gr' }, // Grčka  
    { code: '+36', flag: 'hu' }, // Mađarska  
    { code: '+354', flag: 'is' }, // Island  
    { code: '+353', flag: 'ie' }, // Irska  
    { code: '+39', flag: 'it' }, // Italija  
    { code: '+371', flag: 'lv' }, // Letonija  
    { code: '+423', flag: 'li' }, // Lihtenštajn  
    { code: '+370', flag: 'lt' }, // Litvanija  
    { code: '+352', flag: 'lu' }, // Luksemburg  
    { code: '+356', flag: 'mt' }, // Malta  
    { code: '+373', flag: 'md' }, // Moldavija  
    { code: '+377', flag: 'mc' }, // Monako  
    { code: '+31', flag: 'nl' }, // Holandija  
    { code: '+47', flag: 'no' }, // Norveška  
    { code: '+48', flag: 'pl' }, // Poljska  
    { code: '+351', flag: 'pt' }, // Portugal  
    { code: '+40', flag: 'ro' }, // Rumunija  
    { code: '+421', flag: 'sk' }, // Slovačka  
    { code: '+386', flag: 'si' }, // Slovenija  
    { code: '+34', flag: 'es' }, // Španija  
    { code: '+46', flag: 'se' }, // Švedska  
    { code: '+41', flag: 'ch' }, // Švajcarska  
    { code: '+44', flag: 'gb' }, // Velika Britanija  
    { code: '+90', flag: 'tr' },  // Turska
    { code: '+1', flag: 'us' }, // Sjedinjene Američke Države
    { code: '+1', flag: 'ca' }, // Kanada
    { code: '+61', flag: 'au' }  // Australija
  ];
  selectedPrefix = this.phonePrefixes[0]; // Default: +381 (Srbija)
  dropdownOpen = false;
  inputs = {
    fullName: "",
    ['fullNameChild1']: "",
    phone: "",
    phonePrefix: "+381",
    email: "",
    day: "",
    month: "",
    year: ""
  };
  bookingInfo = {
    cityOrAddress: '',
    roomName: '',
    roomId: '',
    zoneName: '',
    zoneId: '',
    appointmentDateISO: '',
    startTime: '',
    endTime: '',
    timeSlotConfigurationId: ''
  };
  birthdayAdds: { name: string; quantity: string; price: number; }[] = [
    { name: '', quantity: '', price: null }
  ];
  birthDayAdssPriceTotal: number = null
  errMsgInputTime: string = ''
  messageError: string = ''
  errMsgInputDate: string = ''
  ngOnInit() {
    this.birthdayAdd = new BirthdayModelInputDTO();
    this.loadVisit()
    this.fillEmployeeFromStorage();
    this.roomService.getAllPlayroomsSub().subscribe(data => {
      this.playroom = data;

      this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);
      if (this.birthdayAdd.city !== null || '') {

        const foundUser = this.userList.find(u => u.display === this.birthdayAdd.city);
        if (foundUser) {
          this.selectedUser = foundUser;
          this.getReducedArray()
          if (this.birthdayAdd.roomId && this.roomList) {
            const foundRoom = this.roomList.find(
              r => parseInt(r.value) === this.birthdayAdd.roomId
            );
            if (foundRoom) {
              this.selectedRoom = foundRoom;
            }
          }

        }
        this.getReducedZoneArray()
      }
    });
    const visitorId = this.route.snapshot.paramMap.get('id');
    this.isCreateMode = !visitorId;

    if (visitorId) {
      this.birthdayAdd.VisitorId = parseInt(visitorId)
      this.getVisitorFromList(parseInt(visitorId)).subscribe(visitor => {
        if (visitor) {
          this.visitor = visitor;
          this.visitorCh = this.visitor.children

          this.visitor.children = this.visitor.children.map(child => ({
            ...child,
            birthDate: child.birthDate ? child.birthDate.split('T')[0] : ''
          }));
        } else {
          this.roomService.getAllPlayroomsSub().subscribe(data => {
            this.playroom = data;

            this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);
            if (this.birthdayAdd.city !== null || '') {

              const foundUser = this.userList.find(u => u.display === this.birthdayAdd.city);
              if (foundUser) {
                this.selectedUser = foundUser;
                this.getReducedArray()
                if (this.birthdayAdd.roomId && this.roomList) {
                  const foundRoom = this.roomList.find(
                    r => parseInt(r.value) === this.birthdayAdd.roomId
                  );
                  if (foundRoom) {
                    this.selectedRoom = foundRoom;
                  }
                }

              }
              this.getReducedZoneArray()
            }
          });
        }
      });
    } else {
      //prepare empty visitor for create mode
      this.visitor = {
        fullName: '',
        phone: '',
        email: '',
        visitorStatus: 0,
        comment: ''
      } as any;
      this.createChildren = [{ fullName: '', birthDate: '' }];
    }
    this.route.queryParamMap.subscribe(qp => {
      const rawDate = qp.get('AppointmentDate') ?? '';
      const iso = rawDate.slice(0, 10);
      if (iso) {
        const [y, m, d] = iso.split('-').map(Number);
        const dt = new Date(y, m - 1, d);
        const mon = dt.toLocaleString('en-US', { month: 'short' });
        this.bookingInfo.appointmentDateISO = `${String(d).padStart(2, '0')}-${mon}-${y}`;
      } else {
        this.bookingInfo.appointmentDateISO = '';
      }
      const start = qp.get('startTimeBirthday');
      const end = qp.get('endTimeBirthday');
      const roomName = qp.get('roomName');
      const zoneName = qp.get('zoneName');
      const address = qp.get('address');
      const roomId = qp.get('roomId');
      const timeSlotConfigurationId = qp.get('timeSlotConfigurationId');


      console.log("timeSlotConfigurationId", timeSlotConfigurationId)

      const zoneIdRaw =
        qp.get('zoneId') ??
        qp.get('BirthdayZoneId') ??
        qp.get('ZoneId') ??
        null;

      const zoneId = zoneIdRaw && zoneIdRaw.trim() !== '' ? zoneIdRaw : null;

      this.birthdayAdd.roomId = roomId ? parseInt(roomId, 10) : null;
      this.birthdayAdd.BirthdayZoneId = zoneId ? parseInt(zoneId, 10) : null;

      this.bookingInfo.cityOrAddress = address ?? '';
      this.bookingInfo.roomName = roomName ?? '';
      this.bookingInfo.roomId = roomId ?? '';
      this.bookingInfo.zoneName = zoneName ?? '';
      this.bookingInfo.zoneId = zoneId ?? '';
      this.bookingInfo.startTime = start ?? '';
      this.bookingInfo.endTime = end ?? '';
      this.bookingInfo.timeSlotConfigurationId = timeSlotConfigurationId ?? '';
    });

    this.getFlexSlots(this.bookingInfo.appointmentDateISO)
  }

  onConfirmClick(
    cityOrAddress: string = '',
    roomName: string = '',
    roomId: string = '',
    zoneName: string = '',
    zoneId: string = '',
    appointmentDateISO: string = '',
    startTime: string = '',
    endTime: string = '',
    timeSlotConfigurationId: string = '',

  ) {



    const MONTHS: Record<string, number> = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
    const [dStr, monStr, yStr] = (appointmentDateISO || '').split('-');
    const y = Number(yStr || 0);
    const d = Number(dStr || 1);
    const m = MONTHS[monStr as keyof typeof MONTHS] ?? 0;
    const pad = (n: number) => String(n).padStart(2, '0');
    const dateOnly = `${y}-${pad(m + 1)}-${pad(d)}`;


    const startIso = this.combineLocalDateAndHHmmToISO(dateOnly, startTime);
    let endIso = this.combineLocalDateAndHHmmToISO(dateOnly, endTime);

    if (startIso && endIso && new Date(endIso) <= new Date(startIso)) {
      const tmp = new Date(endIso);
      tmp.setDate(tmp.getDate() + 1);
      endIso = tmp.toISOString();
    }

   


    (this.birthdayAdd as any).AppointmentDate = dateOnly;
    (this.birthdayAdd as any).BirthdayStart = startIso;
    (this.birthdayAdd as any).BirthDayEnds = endIso;


    const roomIdNum = roomId?.trim() ? parseInt(roomId, 10) : NaN;
    const zoneIdNum = zoneId?.trim() ? parseInt(zoneId, 10) : NaN;
    this.birthdayAdd.roomId = Number.isFinite(roomIdNum) ? roomIdNum : null;
    this.birthdayAdd.BirthdayZoneId = Number.isFinite(zoneIdNum) ? zoneIdNum : null;
    if (this.selectedRoom?.value) this.birthdayAdd.roomId = parseInt(this.selectedRoom.value, 10);
    

    this.birthdayAdd.VisitorId = this.visitor?.id ?? null;
    this.birthdayAdd.SavedTimeSlotId = parseInt(timeSlotConfigurationId);

    if (this.birthdayAdd.CallStatus !== 0 && this.birthdayAdd.CallStatus !== 5) {

      this.birthdayAdd.SavedTimeSlotId = null
     

    }
    const formValidation = validateBirthDay(this.birthdayAdd);

    this.errMsg = formValidation.errMsg;


    if (formValidation.isValid) {

      this.visitorService.addBirthday(this.birthdayAdd).subscribe({
        next: (res: BirthdayOutput) => {
          this.updateCallStatusOnly(res.id);
          this.presentToast('Rođendan je uspešno dodat.', 'success');
          this.router.navigate(
            ['admin/birthday-booking'],
            {
              replaceUrl: true,
              queryParams: {
                roomId: this.birthdayAdd.roomId,
                zoneId: this.birthdayAdd.BirthdayZoneId,
                appointmentDate: (this.birthdayAdd as any).AppointmentDate,
                birthdayStart: (this.birthdayAdd as any).BirthdayStart
              }
            }
          );
        },
        error: (err) => console.error('[onConfirmClick] ERROR ←', err)
      });

      this.birthdayAdd = new BirthdayModelInputDTO();
      
      this.birthdayAdd.VisitorId = null;
      this.birthdayAdd.BirthdayZoneId = null;
      this.selectedUser = null;
    }
  }
  // --------------------------------------------------------------------------------------------------------------------------------

  addChild() {
    this.createChildren.push({ fullName: '', birthDate: '' });
  }

  removeChild(i: number) {
    if (this.createChildren.length > 1) {
      this.createChildren.splice(i, 1);
    }
  }

  async createVisitor() {
    type ChildInput = { fullName: string; birthDate: string };
    const DEFAULT_BIRTHDATE = '1970-01-01';

    const childrenToSend: ChildInput[] = (this.createChildren ?? [])
      .map(c => {
        const fullName = (c?.fullName ?? '').trim();
        let birth = ((c?.birthDate ?? '') + '').slice(0, 10);
        if (!birth) birth = DEFAULT_BIRTHDATE;
        return { fullName, birthDate: birth };
      })
      .filter(c => !!c.fullName);

    const formValidation = this.validateAddVisitor();
    this.errMsg = formValidation.errMsg;
    if (!formValidation.isValid) return;

    const payloadPhone = (this.inputs?.phonePrefix || '') + (this.visitor?.phone || '');

    this.visitorService
      .saveVisitor(
        { ...this.visitor, phone: payloadPhone },
        childrenToSend
      )
      .subscribe({
        next: (res: any) => {
          if (res?.id) this.visitor.id = res.id;

          if (res?.visitorStatus !== undefined && res?.visitorStatus !== null) {
            this.visitor.visitorStatus = +res.visitorStatus;
          }

          if (!this.visitor.children || !this.visitor.children.length) {
            this.visitor.children = (this.createChildren ?? []).map(c => ({
              fullName: c.fullName,
              birthDate: (c.birthDate || DEFAULT_BIRTHDATE)
            })) as any;
          }

          this.isCreateMode = false;

          this.notifierService.notify('success', 'Uspešno sačuvano.');
        },
        error: (err) => {
          console.error(err);
          this.showErrorAndRedirect?.(err);
        }
      });
  }

  validateAddVisitor() {
    const user = this.visitor;
    let errMsg: string;
    if (!user.fullName) {
      errMsg = 'Unesite ime roditelja / staratelja.';
    } else if (!user.phone) {
      errMsg = 'Unesite broj telefona.';
    } else {
      errMsg = '';
      return { isValid: true, errMsg };
    }
    return { isValid: false, errMsg };
  }

  showErrorAndRedirect(error) {
    this.notifierService.show({
      message: '' + JSON.stringify(error.error.title),
      type: 'warning',
    });

  }

  showSuccessAndRedirect() {
    let message = '';

    this.notifierService.show({
      // eslint-disable-next-line object-shorthand
      message: message,
      type: 'success',
    });
    this.visitor = new Visitor1();
  }

  getVisitorFromList(visitorId: number) {
    return this.visitors$.pipe(
      map(visitors => visitors.find(v => v.id === visitorId) || null)
    );
  }

  get filteredChildren() {
    const children = this.visitor?.children;
    if (!Array.isArray(children)) {
      return [];
    }
    return children.filter(c => typeof c === 'object' && c?.fullName);
  }

  loadVisit() {
    this.currentPage = 1;
    this.visitService.getAllVisitsAdminManagerRoleDirect({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery,
      birthDateQuery: this.birthDateQuery,
      roomQuery: this.roomQuery,
      statusQuery: this.statusQuery,
      dateQuery: this.dateQuery,
      dateQueryEnd: this.dateQueryEnd,
      enterTimeQuery: this.enterTimeQuery,
      enterTimeQueryEnd: this.enterTimeQueryEnd,
      timeZoneQuery: this.timeZoneQuery,
      gratisQuery: this.gratisQuery,
      packageTicketType: this.packageTicketType
    }).subscribe(({ visits, pagination }) => {
      this.visits = visits;
      this.paginationSettings = pagination;

    });
  }

  formatDateForInput(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getCardType(value: number, hours: number): string {
    if (value === 0) {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return 'Sat';
      }
    } else if (value === 1) {
      return 'Poludnevna karta';
    } else if (value === 2) {
      return 'Dnevna karta';
    } else {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return '';
      }
    }
  }

  editVisitor() {
    this.visitorService.editVisitor(this.visitor).subscribe((res) => {
      this.visitorService.getAllVisitorsSearch({
        currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, fullNameQuery: this.fullNameQuery,
        emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren,
        marketingMessageQuery: this.marketingMessageQuery, dateBirthFromQuery: this.dateBirthFromQuery, dateBirthToQuery: this.dateBirthToQuery,
        registrationDateFromQuery: this.registrationDateFromQuery, registrationDateToQuery: this.registrationDateToQuery,
        visitorBirthMonthFromQuery: this.visitorBirthMonthFromQuery, visitorBirthMonthToQuery: this.visitorBirthMonthToQuery,
        visitorBirthYearFromQuery: this.visitorBirthYearFromQuery, visitorBirthYearToQuery: this.visitorBirthYearToQuery
      });
    }, (err) => {
      console.error(err);
    });
  }

  downloadSignature(visitor) {
    const guid = visitor.signatureUrl.split('Signature/')[1];
    this.visitorService.getSignature(guid).subscribe(res => {
      const source = URL.createObjectURL(res);
      const el = document.createElement("a");
      el.setAttribute("href", source);
      el.setAttribute("download", `${visitor.fullName.replace(/\s/g, '_')}${visitor.phone}`);
      document.body.appendChild(el);
      el.click();
      el.remove();
    })
  }

  onUserChange(event: any) {
    this.getReducedArray()
    this.zoneList = []
    this.birthdayAdd.city = this.selectedUser.display
  }

  onRoomChange(event: any) {
    this.selectedZone = null;
    this.zoneList = [];

    if (!this.selectedRoom) {
      console.warn('Nije izabrana igraonica.');
      return;
    }

    this.birthdayAdd.roomId = parseInt(this.selectedRoom.value);
    this.commonMethodsService.getEmployeesByRoom(
      this.birthdayAdd.roomId,
      this.currentPage,
      this.itemsPerPage
    ).subscribe(employees => {
      if (employees.length > 0) {
        this.birthdayAdd.EmployeeId = employees[0].id;
        // this.birthdayAdd.EmployName = employees[0].username;
      }
    });
    this.getReducedZoneArray();

  }

  compareRooms(o1: RoomArray, o2: RoomArray): boolean {
    return o1 && o2 ? parseInt(o1.value) === parseInt(o2.value) : o1 === o2;
  }
  compareZone = (o1: ZoneArray, o2: ZoneArray) => {
    return o1 && o2 ? o1.value === o2.value : o1 === o2;
  };

  onZoneChange(event: any) {
    if (!this.selectedZone) {
      console.warn('selectedZone nije postavljen.');
      return;
    }

    this.birthdayAdd.BirthdayZoneId = parseInt(this.selectedZone.value);
    this.birthdayAdd.AppointmentDate = null
  }

  getReducedArray() {

    this.roomList = []
    var disp = this.selectedUser?.display
    this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, disp);
    this.zoneList = []

  }

  getReducedZoneArray() {
    if (!this.selectedRoom) {
      console.warn('selectedRoom nije postavljen, preskačem mapiranje zona.');
      this.zoneList = [];
      this.selectedZone = null;
      return;
    }

    this.rodjendanskezoneservice.getAllPlayroomZonesSub({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage
    }).subscribe(data => {
      this.zone = data;

      const disp = this.selectedRoom.display;
      this.zoneList = this.commonMethodsService.mapPlayroomsToZoneList(this.zone, disp);

      if (this.zoneList.length > 0 && this.birthdayAdd.BirthdayZoneId) {
        const foundZone = this.zoneList.find(
          z => parseInt(z.value) === this.birthdayAdd.BirthdayZoneId
        );
        this.selectedZone = foundZone ?? null;
      } else {
        this.selectedZone = null;
      }

    });
  }

  onAvansChange(event: any) {
    this.birthdayAdd.advancePaymentWill
  }

  getStartTimeQuery(val: Date | string): string {
    const date = new Date(val);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  getEndTimeQuery(val) {
    const date = new Date(val);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;

  }

  onAppoitmentDateChanged() {
    this.birthdayAdd.startTimeBirthday = null
    const appointmentDate = new Date(this.birthdayAdd.AppointmentDate);
    const fromDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate(),
      0, 0, 0
    ));

    const toDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate() + 1,
      0, 0, 0
    ));


    console.log(
      'const appointmentDate', appointmentDate,
      'this.birthdayAdd.AppointmentDate', this.birthdayAdd.AppointmentDate,
      'fromDate', fromDate,
      'toDate', toDate

    )
    this.visitorService.getSavedTimeSlots(
      this.birthdayAdd.roomId,
      this.birthdayAdd.BirthdayZoneId,
      fromDate,
      toDate
    ).subscribe({
      next: (slots) => {
        // Konvertuj UTC slotove u lokalno vreme
        const dateContext = typeof this.birthdayAdd.AppointmentDate === 'string' 
          ? this.birthdayAdd.AppointmentDate 
          : this.birthdayAdd.AppointmentDate.toISOString();
        this.availibleslots = slots.map(slot => ({
          ...slot,
          start: this.fromUtcToLocalTime(slot.start, dateContext),
          end: this.fromUtcToLocalTime(slot.end, dateContext)
        }));

      },

      error: err => console.error('Greška:', err)
    });
    console.log(' this.availibleslots KARTICA CONSOLE VAN NEXT', this.availibleslots)
  }

  private fromUtcToLocalTime(utcTimeStr: string, dateContext: string): string {
    // Kombinuje datum konteksta sa UTC vremenom i konvertuje u lokalno vreme
    const dateOnly = dateContext.split('T')[0];
    const fullUtcStr = `${dateOnly}T${utcTimeStr}${utcTimeStr.includes('Z') ? '' : 'Z'}`;
    const localDate = new Date(fullUtcStr);
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  onPhoneChange(): void {
    if (!this.isCreateMode) return;

    const raw0 = (this.visitor?.phone || '').trim();
    const raw = raw0.replace(/[ \-()./]/g, '');
    if (!raw || raw.length < 6) return;

    const pref = (this.inputs?.phonePrefix || this.selectedPrefix?.code || '').trim();
    const prefPlus = pref.startsWith('+') ? pref : ('+' + pref);
    const prefNoPlus = prefPlus.slice(1);

    let fullPhone: string;
    if (raw.startsWith('+')) fullPhone = raw;
    else if (raw.startsWith(prefNoPlus)) fullPhone = '+' + raw;
    else fullPhone = prefPlus + raw.replace(/^0+/, '');

    const stripCurrentPrefix = (num: string) => {
      const n = (num || '').replace(/[ \-()./]/g, '');
      if (n.startsWith(prefPlus)) return n.slice(prefPlus.length);
      if (n.startsWith(prefNoPlus)) return n.slice(prefNoPlus.length);
      return n;
    };

    this.visitorService.getParentByPhone(fullPhone).subscribe(parent => {
      if (!parent) return;

      this.visitor.id = parent.id;
      this.visitor.fullName = parent.fullName ?? '';
      this.visitor.email = parent.email ?? '';
      this.visitor.visitorStatus = parent.visitorStatus ?? 0;
      this.visitor.comment = parent.comment ?? '';

      this.visitor.phone = stripCurrentPrefix(parent.phone ?? fullPhone);
      this.isCreateMode = false;
      const kids = Array.isArray(parent.children) ? parent.children : [];
      this.visitor.children = kids.map(c => ({
        ...c,
        birthDate: c?.birthDate ? String(c.birthDate).slice(0, 10) : ''
      }));
      this.createChildren = this.visitor.children.map(c => ({
        fullName: c.fullName || '',
        birthDate: c.birthDate || ''
      }));
    });
  }

  private updateCallStatusOnly(birthId: number): void {
    const callId = Number(localStorage.getItem('callId') ?? NaN);

    this.callListService.setBirthdayCall(birthId, callId).subscribe({
      next: () => { },
      error: err => console.error('Greška pri ažuriranju statusa rođendana:', err)
    });
    localStorage.removeItem("callid");
  }

  selectPrefix(prefix: { code: string; flag: string }) {
    this.selectedPrefix = prefix;
    this.inputs.phonePrefix = prefix.code;
    this.dropdownOpen = false;
  }

  combineLocalDateAndHHmmToISO(
    ymd: string | null | undefined,
    hhmm: string | null | undefined
  ): string | null {
    if (!ymd || !hhmm) return null;

    const [y, m, d] = ymd.split("-").map(Number);
    const [hh, mm] = hhmm.split(":").map(Number);

    const local = new Date(y, (m || 1) - 1, d || 1, hh || 0, mm || 0, 0, 0);
    return isNaN(local.getTime()) ? null : local.toISOString();
  }



  private readUserFromStorage(): any | null {
    const STORAGE_KEYS = ['currentUser', 'loggedUser', 'user'];
    for (const k of STORAGE_KEYS) {
      const raw = localStorage.getItem(k) || sessionStorage.getItem(k);
      if (!raw) continue;
      try {
        const obj = JSON.parse(raw);
        if (obj && ('unique_name' in obj || 'nameid' in obj)) return obj;
      } catch { }
    }

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)!;
      try {
        const obj = JSON.parse(localStorage.getItem(key)!);
        if (obj && ('unique_name' in obj || 'nameid' in obj)) return obj;
      } catch { }
    }
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)!;
      try {
        const obj = JSON.parse(sessionStorage.getItem(key)!);
        if (obj && ('unique_name' in obj || 'nameid' in obj)) return obj;
      } catch { }
    }
    return null;
  }

  private fillEmployeeFromStorage(): void {
    const u = this.readUserFromStorage();
    if (!u) {
      console.warn('[fillEmployeeFromStorage] Nije pronađen user JSON u storage-u.');
      return;
    }

    this.birthdayAdd.EmployeeId = Number(u.nameid) || null;
    this.birthdayAdd.EmployName = String(u.unique_name || '');

    console.log('[fillEmployeeFromStorage] →', {
      EmployeeId: this.birthdayAdd.EmployeeId,
      EmployName: this.birthdayAdd.EmployName
    });
  }

  statusCallHelper(value: number) {
    if (value === 0) {
      return "ZAKAZAN"
    }
    else if (value === 1) {
      return "OTKAZAN"
    }
    else if (value === 2) {
      return "RASPITUJE SE"

    }
    else if (value === 3) {
      return "RAZMISLIĆE"

    }

    else if (value === 4) {
      return "POZVATI GA"

    }


  }

  onAddsPriceChange(event: any) {
    this.recalculateTotal()
  }
  private recalculateTotal() {
    this.birthDayAdssPriceTotal = 0;
    for (let j = 0; j < this.birthdayAdds.length; j++) {
      this.birthDayAdssPriceTotal += this.birthdayAdds[j].price;
    }
    console.log("Total:", this.birthDayAdssPriceTotal)
    console.log("TotalArray Adds:", this.birthdayAdds)
    this.birthdayAdd.AddsTotalNamePrices = this.birthdayAdds
    this.birthdayAdd.TotalPricePaidWithAdds = this.birthdayAdd.TotalPricePaid + this.birthDayAdssPriceTotal
    this.birthdayAdd.TotalPricePaidAdds = this.birthDayAdssPriceTotal
  }

  onPriceNumberBlur(idx: number) {
    const v = +this.birthdayAdds[idx].price;
    if (isNaN(v)) return;
    this.birthdayAdds[idx].price = Math.round((v + Number.EPSILON) * 100) / 100;
    this.onAddsPriceChange(null);
  }

  addInputField() {
    this.birthdayAdds.push({ name: '', quantity: '', price: 0 });

  }


  removeInputField(index: number) {

    if (this.birthdayAdds.length === 1 && index === 0 && this.birthDayAdssPriceTotal === 0) {

      return
    }

    else if (this.birthdayAdds.length === 1 && index === 0 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.addInputField()
      this.recalculateTotal()

    }

    else if (index === 0 && this.birthdayAdds.length > 1 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.recalculateTotal()
    }

    else if (index > 0 && this.birthdayAdds.length > 1 && this.birthDayAdssPriceTotal > 0) {
      this.birthdayAdds.splice(index, 1);
      this.recalculateTotal()


    }
  }
  getFlexSlots(slotDate) {

    console.log("DATE", slotDate)


    const appointmentDate = new Date(slotDate);
    const fromDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate(),
      0, 0, 0
    ));

    const toDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate() + 1,
      0, 0, 0
    ));


    console.log(
      'const appointmentDate', appointmentDate,
      'this.birthdayAdd.AppointmentDate', this.birthdayAdd.AppointmentDate,
      'fromDate', fromDate,
      'toDate', toDate,

    )

    this.visitorService.getSavedTimeSlots(
      this.birthdayAdd.roomId,
      this.birthdayAdd.BirthdayZoneId,
      fromDate,
      toDate
    ).subscribe({
      next: (slots) => {
        // Konvertuj UTC slotove u lokalno vreme
        const dateContext = typeof this.birthdayAdd.AppointmentDate === 'string' 
          ? this.birthdayAdd.AppointmentDate 
          : this.birthdayAdd.AppointmentDate.toISOString();
        this.availibleslots = slots.map(slot => ({
          ...slot,
          start: this.fromUtcToLocalTime(slot.start, dateContext),
          end: this.fromUtcToLocalTime(slot.end, dateContext)
        }));
        console.log(' this.availibleslots KARTICA CONSOLE VAN NEXT', this.availibleslots)
        this.birthdayAdd.isFlexible = false;
        for (let s = 0; s < this.availibleslots.length; s++) {

          if (this.availibleslots[s].isFlexible === true) {
            this.birthdayAdd.isFlexible = true;
            break;
          }


        }
      },
      error: (error) => {

        if (error.error.errors.includes('Appoitment-day-is-less-than-call-date')) {
          this.messageError = 'Datum zakazanong rođendana ne može biti manji od datuma poziva';
          alert('Datum zakazanong rođendana ne može biti manji od datuma poziva');
          this.birthdayAdd.AppointmentDate = null
        }
        this.errMsgInputDate = this.messageError

      }

    });
  }


  onEndTimeChangedFlex() {
    this.birthdayAdd.SavedTimeSlotId = parseInt(this.bookingInfo.timeSlotConfigurationId)
    if (this.bookingInfo.appointmentDateISO && this.birthdayAdd.endTimeBirthday) {
      console.log('this.birthdayAdd.ENDTimeBirthday', this.birthdayAdd.endTimeBirthday)
      this.errMsgInputTime = '';
      const [hours, minutes] = this.birthdayAdd.endTimeBirthday.split(':').map(Number);

      const date = new Date(this.bookingInfo.appointmentDateISO);
      console.log('date', date)
      date.setHours(hours, minutes, 0, 0);

      this.birthdayAdd.BirthDayEndsDt = date;
      console.log('this.birthdayAdd.BirthDayEndsDt', this.birthdayAdd.BirthDayEndsDt)
      this.birthdayAdd.BirthDayEnds = new Date(
        this.birthdayAdd.BirthDayEndsDt
      ).toISOString();
      console.log('this.birthdayAdd.BirthDayEnds', this.birthdayAdd.BirthDayEnds)

      const date1 = new Date(this.birthdayAdd.BirthDayEnds);
      const hours1 = String(date.getHours()).padStart(2, '0');
      const minutes1 = String(date.getMinutes()).padStart(2, '0');
      const formattedTime = `${hours1}:${minutes1}`;
      this.bookingInfo.endTime = formattedTime
      console.log('this.bookingInfo.start time', this.bookingInfo.startTime)

      for (let i = 0; i < this.availibleslots.length; i++) {

        console.log("STARTSLOT U END SLOT METODI", this.birthdayAdd.SavedTimeSlotId)
        if (this.birthdayAdd.SavedTimeSlotId === null) {

          this.birthdayAdd.SavedTimeSlotId = -1
        }


        if (this.availibleslots[i].start === this.birthdayAdd.endTimeBirthday) {
          this.birthdayAdd.SavedTimeEndSlotId = this.availibleslots[i].id
          console.log("ENDSLOT U END SLOT METODI", this.birthdayAdd.SavedTimeEndSlotId)

          this.visitorService.getSavedTimeSlotByIdStartEnd(this.birthdayAdd.SavedTimeSlotId, this.birthdayAdd.SavedTimeEndSlotId).subscribe({
            next: (data) => {

              console.log('Slot data:', data);
            },
            error: (error) => {

              if (error.error.errors.includes('Slots cant be null')) {
                this.messageError = 'Morate uneti vremena početka i završetka rodjendana.';
                alert('Morate uneti vremena početka i završetka rodjendana!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeEndSlotId = null

              }
              else if (error.error.errors.includes('Birthday-appoitment - is- allredy-booked')) {
                this.messageError = 'Termin je zauzet.';
                alert('Termin je zauzet!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeEndSlotId = null
              }
              else if (error.error.errors.includes('EndTime - and- StartTime cant be same')) {
                this.messageError = 'Vreme završetka rođendana mora biti veće od vremena početka rođendana.';
                alert('Vreme završetka rođendana mora biti veće od vremena početka rođendana!');
                this.birthdayAdd.endTimeBirthday = ''
                this.birthdayAdd.startTimeBirthday = null
                this.birthdayAdd.SavedTimeSlotId = null
                this.birthdayAdd.SavedTimeEndSlotId = null

              }

              else {
                console.error('Neočekivana greška:', error);
              }
              this.errMsgInputTime = this.messageError



            }
          });
          this.birthdayAdd.SavedTimeEndSlotId = this.availibleslots[i].id
          break;
        }
      }
    }
  }

  isRetroDate(): boolean {
    const iso = this.bookingInfo.appointmentDateISO;
    if (!iso) return false;

    const MONTHS: Record<string, number> = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
    const [dStr, monStr, yStr] = iso.split('-');
    const y = Number(yStr || 0);
    const d = Number(dStr || 1);
    const m = MONTHS[monStr as keyof typeof MONTHS] ?? 0;

    const selected = new Date(y, m, d);
    selected.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selected < today;
  }
  onPlannedChildNumberChange(event: any) {

    const planned = Number(this.birthdayAdd.PlannedChildNumber);
    const price = Number(this.birthdayAdd.PricePerChildren);
    console.log("PLANNED", planned)
    console.log("PRICE", price)
    this.birthdayAdd.TotalPricePaidWithoutDicount = planned * price;
    this.onDiscountChange(event)
    this.recalculateTotal()
  }
  onDiscountChange(event: any) {

    this.birthdayAdd.TotalPricePaid = this.birthdayAdd.TotalPricePaidWithoutDicount - (this.birthdayAdd.TotalPricePaidWithoutDicount * this.birthdayAdd.Discount / 100)
    this.recalculateTotal()
  }
  onPricePerChildrenChange(event: any) {

    this.onPlannedChildNumberChange(event)
  }
  onFullPriceChange(event: any) {

    this.onDiscountChange(event)
    this.recalculateTotal()
  }
}